"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WidgetShell = void 0;
var _whichDevice = require("./utils/whichDevice");
var _gates = require("./constants/gates");
var _receivedPostMessageTypes = require("./iframe-communication/constants/receivedPostMessageTypes");
var _sentPostMessageTypes = require("./iframe-communication/constants/sentPostMessageTypes");
var _PostMessageReceiver = require("./iframe-communication/PostMessageReceiver");
var _PageTitleNotificationsPlugin = _interopRequireDefault(require("./page-title-notifications/PageTitleNotificationsPlugin"));
var _getWidgetDataResponseType = require("./operators/getWidgetDataResponseType");
var _operators = require("./cookies/operators");
var _constants = require("./cookies/constants");
var _times = _interopRequireDefault(require("./cookies/times"));
var _clearCookies = require("./cookies/clearCookies");
var _widgetClassNames = require("./constants/widgetClassNames");
var _widgetResponseTypes = require("./constants/widgetResponseTypes");
var _setMessagesUtk = require("./utk/setMessagesUtk");
var _isEmbeddedInProduct = require("./utils/isEmbeddedInProduct");
var _shouldRenderWidget = require("./utils/shouldRenderWidget");
var _shouldWidgetStartOpen = require("./utils/shouldWidgetStartOpen");
var _elementSelectors = require("./constants/elementSelectors");
var _setupExternalApi = require("./external-api/setupExternalApi");
var _flushOnReadyCallbacks = require("./external-api/flushOnReadyCallbacks");
var _DevLogger = _interopRequireDefault(require("./external-api/DevLogger"));
var _EventEmitter = _interopRequireDefault(require("./event-emitter/EventEmitter"));
var _handleExternalApiEventMessage = require("./event-emitter/handleExternalApiEventMessage");
var _fetchWidgetData = require("./requests/fetchWidgetData");
var _events = require("./events");
var _throttle = require("./utils/throttle");
var _getIframeQueryParams = require("./utils/getIframeQueryParams");
var _settingsHelpers = require("./external-api/settingsHelpers");
var _ScrollPercentageTracker = _interopRequireDefault(require("./scroll-percentage/ScrollPercentageTracker"));
var _ExitIntentTracker = _interopRequireDefault(require("./exit-intent/ExitIntentTracker"));
var _markEnd = require("./perf/markEnd");
var _setClassInClassList = require("./operators/setClassInClassList");
var _widgetDataKeys = require("./constants/widgetDataKeys");
var _resetAndLaunchWidget = require("./utk/resetAndLaunchWidget");
var _extendedFunctions = require("./constants/extendedFunctions");
var _ApiUsageTracker = require("./external-api/ApiUsageTracker");
var _PostMessageApiClient = require("./iframe-communication/PostMessageApiClient");
var _sendWidgetDataToIframe = require("./postMessageMethods/sendWidgetDataToIframe");
var _registerCookieListeners = require("./cookies/registerCookieListeners");
var _registerHashChangeListener = require("./event-listener/registerHashChangeListener");
var _registerWindowResizeListener = require("./event-listener/registerWindowResizeListener");
var _iframeMessagePool = require("./postMessageQueue/iframeMessagePool");
var _hideWelcomeMessage = require("./utils/hideWelcomeMessage");
var _resizeWidgetIframe = require("./utils/resizeWidgetIframe");
var _handleTargetingAndDelay = require("./utils/handleTargetingAndDelay");
var _getGlobalCookieOptOut = require("./utk/getGlobalCookieOptOut");
var _gdprCookieConsentTypes = require("conversations-internal-schema/widget-data/constants/gdprCookieConsentTypes");
var _deleteCookie = require("./cookies/deleteCookie");
var _eventTypeConstants = require("./event-emitter/constants/eventTypeConstants");
var _getExternalApiSettings = require("./external-api/getExternalApiSettings");
var _ScreenCapturePlugin = require("./screen-capture/ScreenCapturePlugin");
var _WidgetColors = require("visitor-ui-component-library/constants/WidgetColors");
var _launcherTypes = require("conversations-internal-schema/widget-data/constants/launcherTypes");
const HELP_WIDGET_ID = 'help-widget';
const noop = () => {};
class WidgetShell {
  constructor(embedScriptContext, errorLogger, eventEmitter) {
    this.handleDragStart = e => {
      const parent = document.getElementById(_elementSelectors.PARENT_ID);
      this.isDragging = true;
      const isRightAligned = this.widgetData[_widgetDataKeys.WIDGET_LOCATION] === 'RIGHT_ALIGNED';
      this.offsetX = isRightAligned ? parent.getBoundingClientRect().right - e.clientX : e.clientX - parent.getBoundingClientRect().left;
      this.offsetY = parent.getBoundingClientRect().bottom - e.clientY;

      // Show Drag Overlay
      if (this.dragOverlayEl instanceof HTMLDivElement) {
        this.dragOverlayEl.style.setProperty('display', 'block');
      }
      if (this.dragHandleEl instanceof HTMLDivElement) {
        this.dragHandleEl.style.setProperty('cursor', 'grabbing');
      }
    };
    this.handleDragEnd = () => {
      if (!this.dragHandleEl || !this.isDragging) {
        return;
      }
      this.iframeMessage.post(_sentPostMessageTypes.TRACK_WIDGET_DRAGGED, {
        // eslint-disable-next-line compat/compat
        timeOnPage: performance && Math.round(performance.now() / 1000),
        isOpen: this.isOpen || false
      });
      this.dragHandleEl.style.setProperty('cursor', 'grab');
      if (this.dragOverlayEl instanceof HTMLDivElement) {
        this.dragOverlayEl.style.setProperty('display', 'none');
      }
      this.isDragging = false;
      const isRightAligned = this.widgetData ? this.widgetData[_widgetDataKeys.WIDGET_LOCATION] === 'RIGHT_ALIGNED' : 'RIGHT_ALIGNED';
      const widgetAlignment = isRightAligned ? 'right' : 'left';
      const cookieKey = `${_constants.cookies.WIDGET_POSITION}_${widgetAlignment}`;
      const parentEl = document.getElementById(_elementSelectors.PARENT_ID);
      const style = window.getComputedStyle(parentEl);
      const bottom = parseInt(style.bottom, 10);
      const horizontal = isRightAligned ? parseInt(style.right, 10) : parseInt(style.left, 10);
      if (!horizontal && !bottom) {
        parentEl.style.removeProperty(widgetAlignment);
        parentEl.style.removeProperty('bottom');
        (0, _deleteCookie.deleteCookie)(cookieKey);
      } else {
        (0, _operators.setCookie)(cookieKey, JSON.stringify({
          bottom,
          horizontal
        }), _times.default.THIRTY_MINUTES);
      }
    };
    this.handleDrag = e => {
      if (!this.isDragging) return;
      const parent = document.getElementById(_elementSelectors.PARENT_ID);
      const isRightAligned = this.widgetData ? this.widgetData[_widgetDataKeys.WIDGET_LOCATION] === 'RIGHT_ALIGNED' : 'RIGHT_ALIGNED';
      const widgetAlignment = isRightAligned ? 'right' : 'left';
      const horizontal = isRightAligned ? window.innerWidth - e.clientX - this.offsetX : e.clientX - this.offsetX;
      const bottom = window.innerHeight - e.clientY - this.offsetY;
      parent.style.setProperty(widgetAlignment, `${Math.min(Math.max(0, horizontal), window.innerWidth - parent.clientWidth)}px`, 'important');
      parent.style.setProperty('bottom', `${Math.min(Math.max(0, bottom), window.innerHeight - parent.clientHeight)}px`, 'important');
      parent.style.setProperty('position', 'fixed', '!important');
    };
    this.unintializeDrag = () => {
      if (!this.dragHandleEl) {
        return;
      }
      this.dragHandleEl.removeEventListener('mousedown', this.handleDragStart);
      window.removeEventListener('mousemove', this.handleDrag);
      window.removeEventListener('mouseup', this.handleDragEnd);
      window.removeEventListener('mouseleave', this.handleDragEnd);
      this.dragHandleEl.remove();
    };
    this.initalizeDrag = () => {
      const {
        draggable
      } = this.widgetData;
      if (!draggable || (0, _whichDevice.isAnyMobile)() || (0, _getExternalApiSettings.getExternalApiSettings)().isFullscreen) {
        return;
      }

      // Create Drag Handle Element
      this.dragHandleEl = document.createElement('div');
      this.dragHandleEl.classList.add('hs-drag-handle');
      this.dragHandleEl.title = 'Drag';
      this.dragHandleEl.style.setProperty('color', _WidgetColors.NEUTRAL_800);
      this.dragHandleEl.innerHTML = `
    <svg width="12" height="20" viewBox="0 0 6 10" fill="${_WidgetColors.NEUTRAL_800}" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.62497 1.20703C5.62497 1.68828 5.23122 2.08203 4.74997 2.08203C4.26872 2.08203 3.87497 1.68828 3.87497 1.20703C3.87497 0.725781 4.26872 0.332031 4.74997 0.332031C5.23122 0.332031 5.62497 0.725781 5.62497 1.20703ZM1.83185 1.20703C1.83185 1.68828 1.4381 2.08203 0.956848 2.08203C0.475598 2.08203 0.0818481 1.68828 0.0818481 1.20703C0.0818481 0.725781 0.475598 0.332031 0.956848 0.332031C1.4381 0.332031 1.83185 0.725781 1.83185 1.20703ZM5.62497 5.00016C5.62497 5.48141 5.23122 5.87516 4.74997 5.87516C4.26872 5.87516 3.87497 5.48141 3.87497 5.00016C3.87497 4.51891 4.26872 4.12516 4.74997 4.12516C5.23122 4.12516 5.62497 4.51891 5.62497 5.00016ZM1.83185 5.00016C1.83185 5.48141 1.4381 5.87516 0.956848 5.87516C0.475598 5.87516 0.0818481 5.48141 0.0818481 5.00016C0.0818481 4.51891 0.475598 4.12516 0.956848 4.12516C1.4381 4.12516 1.83185 4.51891 1.83185 5.00016ZM5.62497 8.79328C5.62497 9.27453 5.23122 9.66828 4.74997 9.66828C4.26872 9.66828 3.87497 9.27453 3.87497 8.79328C3.87497 8.31203 4.26872 7.91828 4.74997 7.91828C5.23122 7.91828 5.62497 8.31203 5.62497 8.79328ZM1.83185 8.79328C1.83185 9.27453 1.4381 9.66828 0.956848 9.66828C0.475598 9.66828 0.0818481 9.27453 0.0818481 8.79328C0.0818481 8.31203 0.475598 7.91828 0.956848 7.91828C1.4381 7.91828 1.83185 8.31203 1.83185 8.79328Z"/>
    </svg>
    `;

      // Create Drag Overlay Element
      this.dragOverlayEl = document.createElement('div');
      this.dragOverlayEl.classList.add('hs-drag-overlay');

      // Add Drag Handle and Overlay to Widget
      const parent = document.getElementById(_elementSelectors.PARENT_ID);
      parent.appendChild(this.dragOverlayEl);
      parent.appendChild(this.dragHandleEl);
      parent.style.setProperty('user-select', 'none');

      // Add Event Listeners
      this.dragHandleEl.addEventListener('mousedown', this.handleDragStart);
      window.addEventListener('mousemove', this.handleDrag);
      window.addEventListener('mouseup', this.handleDragEnd);
      window.addEventListener('mouseleave', this.handleDragEnd);
    };
    this.getDefaultSize = () => {
      return {
        width: 100,
        height: 96
      };
    };
    this.getStartPosition = () => {
      if (!this.widgetData.draggable || (0, _whichDevice.isAnyMobile)() || (0, _getExternalApiSettings.getExternalApiSettings)().isFullscreen) {
        return null;
      }
      const isRightAligned = this.widgetData ? this.widgetData[_widgetDataKeys.WIDGET_LOCATION] === 'RIGHT_ALIGNED' : 'RIGHT_ALIGNED';
      const widgetAlignment = isRightAligned ? 'right' : 'left';
      const cookieKey = `${_constants.cookies.WIDGET_POSITION}_${widgetAlignment}`;
      const cookie = (0, _operators.getCookie)(cookieKey);
      if (cookie) {
        try {
          return JSON.parse(cookie);
        } catch (e) {
          // eslint-disable-next-line no-console
          console.error('Error parsing cookie', e);
          return null;
        }
      } else {
        return null;
      }
    };
    this.loadIFrame = () => {
      var _this$widgetData$gate;
      if ((0, _whichDevice.isAnyMobile)()) {
        document.documentElement.classList.add(_widgetClassNames.MOBILE);
      }
      const iframe = document.createElement('iframe');
      this.iframeSrc = this.embedScriptContext.getIFrameSrc();
      iframe.src = this.iframeSrc;
      iframe.id = _elementSelectors.IFRAME_ID;
      iframe.title = 'Chat Widget';
      iframe.allowFullscreen = true;
      iframe.setAttribute('data-test-id', 'chat-widget-iframe');
      iframe.addEventListener('load', this.handleIframeLoad);
      const parent = document.createElement('div');
      parent.role = 'region';
      parent.ariaLabel = 'Chat Widget';
      if ((_this$widgetData$gate = this.widgetData.gates) !== null && _this$widgetData$gate !== void 0 && _this$widgetData$gate[_gates.COLOR_SCHEME_ISOLATION_GATE]) {
        parent.style.colorScheme = 'light';
      }

      /**
       * Inline embed
       */
      if ((0, _settingsHelpers.shouldEmbedInline)()) {
        const embedElement = document.querySelector((0, _settingsHelpers.getInlineEmbedSelector)());
        if (!embedElement) {
          this.devLogger.error(`cannot embed widget - element at \`${(0, _settingsHelpers.getInlineEmbedSelector)()}\` cannot be found`);
          return;
        }
        parent.id = _elementSelectors.INLINE_PARENT_ID;
        iframe.id = _elementSelectors.INLINE_IFRAME_ID;
        this.iframe = parent.appendChild(iframe);
        embedElement.appendChild(parent);
        return;
      }

      /**
       * Normal embed
       */
      if (document.getElementById(_elementSelectors.PARENT_ID)) {
        // eslint-disable-next-line no-console
        console.warn(`Element with id ${_elementSelectors.PARENT_ID} already exists. Unable to load HubSpot Conversations Widget.`);
        return;
      }
      parent.id = _elementSelectors.PARENT_ID;
      if ((0, _getExternalApiSettings.getExternalApiSettings)().shouldHideChatOnPrint) {
        parent.classList.add(_widgetClassNames.WIDGET_HIDE_ON_PRINT);
      }
      const startPosition = this.getStartPosition();
      if (startPosition) {
        const isRightAligned = this.widgetData[_widgetDataKeys.WIDGET_LOCATION] === 'RIGHT_ALIGNED';
        const widgetAlignment = isRightAligned ? 'right' : 'left';
        parent.style.setProperty(widgetAlignment, `${startPosition.horizontal}px`, 'important');
        parent.style.setProperty('bottom', `${startPosition.bottom}px`, 'important');
      }
      const {
        height,
        width
      } = this.getDefaultSize();
      parent.style.minHeight = `${height}px`;
      parent.style.minWidth = `${width}px`;
      const shadowContainer = document.createElement('div');
      shadowContainer.className = _widgetClassNames.SHADOW_CONTAINER;
      const embeddedInProduct = (0, _isEmbeddedInProduct.isEmbeddedInProduct)(this.embedScriptContext);
      if (embeddedInProduct) {
        parent.classList.add(_widgetClassNames.INTERNAL);
        shadowContainer.classList.add(_widgetClassNames.INTERNAL);
      }
      parent.appendChild(shadowContainer);
      if (embeddedInProduct) {
        iframe.id = HELP_WIDGET_ID;
      }
      this.iframe = parent.appendChild(iframe);
      document.body.appendChild(parent);
      this.initalizeDrag();
      this.setFrameClass();
    };
    this.handleI18nLabels = ({
      data
    }) => {
      if (!this.iframe || !data) return;
      const frameLabel = data['conversations-visitor-ui.visitorExperienceAriaLabels.chatWidget'];
      const dragHandleLabel = data['conversations-visitor-experience-components.visitorExperienceAriaLabels.drag'];
      const parent = document.getElementById((0, _settingsHelpers.shouldEmbedInline)() ? _elementSelectors.INLINE_PARENT_ID : _elementSelectors.PARENT_ID);
      if (frameLabel) {
        this.iframe.setAttribute('title', frameLabel);
        if (parent) {
          parent.ariaLabel = frameLabel;
        }
      }
      if (dragHandleLabel && this.dragHandleEl) {
        this.dragHandleEl.setAttribute('title', dragHandleLabel);
      }
    };
    this.clampPosition = () => {
      var _this$widgetData;
      // Do Not Clamp Position if Draggable Chat is not enabled
      if (!((_this$widgetData = this.widgetData) !== null && _this$widgetData !== void 0 && _this$widgetData.draggable) || (0, _whichDevice.isAnyMobile)() || (0, _getExternalApiSettings.getExternalApiSettings)().isFullscreen) {
        return;
      }
      let hasChanged = false;
      const parent = document.getElementById(_elementSelectors.PARENT_ID);
      const isRightAligned = this.widgetData[_widgetDataKeys.WIDGET_LOCATION] === 'RIGHT_ALIGNED';
      if (!parent || !parent.getBoundingClientRect) {
        // Return if parent is not found (or is being used in a test and doesn't have getBoundingClientRect)
        return;
      }
      const {
        top,
        left,
        right
      } = parent.getBoundingClientRect();
      const {
        innerWidth,
        innerHeight
      } = window;
      const {
        clientWidth,
        clientHeight
      } = parent;
      if (top < 0) {
        hasChanged = true;
        parent.style.setProperty('bottom', `${Math.max(innerHeight - clientHeight, 0)}px`, 'important');
      }
      if (isRightAligned && left < 0) {
        hasChanged = true;
        parent.style.setProperty('right', `${Math.max(innerWidth - clientWidth, 0)}px`, 'important');
      }
      if (!isRightAligned && innerWidth - right < 0) {
        hasChanged = true;
        parent.style.setProperty('left', `${Math.max(innerWidth - clientWidth, 0)}px`, 'important');
      }
      if (hasChanged) {
        this.handleDragEnd();
      }
    };
    this.setWidgetData = widgetData => {
      this.widgetData = widgetData;
      this.setFrameClass();
    };
    this.embedScriptContext = embedScriptContext;

    // Drag Functionality
    this.dragHandleEl = null;
    this.dragOverlayEl = null;
    this.isDragging = false;
    this.offsetX = 0;
    this.offsetY = 0;
    this.isOpen = (0, _shouldWidgetStartOpen.shouldWidgetStartOpen)();
    this.iframe = null;
    this.iframeSrc = null;
    this.hasLoadedIframe = false;
    this.isLoadingIframe = false;
    this.requestWidgetOpen = this.requestWidgetOpen.bind(this);
    this.requestWidgetClose = this.requestWidgetClose.bind(this);
    this.requestWidgetRefresh = (0, _throttle.throttle)(this.requestWidgetRefresh.bind(this), 1000);
    this.requestSetInputText = this.requestSetInputText.bind(this);
    this.handleWindowResize = this.handleWindowResize.bind(this);
    this.handleIframeLoad = this.handleIframeLoad.bind(this);
    this.handleResizeMessage = this.handleResizeMessage.bind(this);
    this.handleResizeDragExpand = this.handleResizeDragExpand.bind(this);
    this.handleStoreWidgetSizePreference = this.handleStoreWidgetSizePreference.bind(this);
    this.handleOpenChange = this.handleOpenChange.bind(this);
    this.handleStoreMessagesCookie = this.handleStoreMessagesCookie.bind(this);
    this.handleRequestWidget = this.handleRequestWidget.bind(this);
    this.handleWidgetRefresh = this.handleWidgetRefresh.bind(this);
    this.setWidgetNotLoaded = this.setWidgetNotLoaded.bind(this);
    this.removeIframe = this.removeIframe.bind(this);
    this.handleExternalApiEventMessage = this.handleExternalApiEventMessage.bind(this);
    this.loadWidget = (0, _throttle.throttle)(this.loadWidget.bind(this), 1000);
    this.resetAndReloadWidget = this.resetAndReloadWidget.bind(this);
    this.setWidgetOpenCookie = this.setWidgetOpenCookie.bind(this);
    this.getStatus = this.getStatus.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.handleExitIntent = this.handleExitIntent.bind(this);
    this.extendedClearCookiesFunction = this.extendedClearCookiesFunction.bind(this);
    this.openToNewThread = this.openToNewThread.bind(this);
    this.handleDragHandlePositionChange = this.handleDragHandlePositionChange.bind(this);
    this.handleInputTextChanged = this.handleInputTextChanged.bind(this);
    this.handleRestoreSavedLauncherPosition = this.handleRestoreSavedLauncherPosition.bind(this);
    this.handleResetToDefaultLauncherPosition = this.handleResetToDefaultLauncherPosition.bind(this);
    this.devLogger = new _DevLogger.default();
    this.eventEmitter = eventEmitter || new _EventEmitter.default();
    this.logError = errorLogger ? errorLogger.logError : noop;
    this.scrollPercentageTracker = new _ScrollPercentageTracker.default({
      onScroll: this.handleScroll
    });
    this.exitIntentTracker = new _ExitIntentTracker.default({
      onExitIntent: this.handleExitIntent
    });
    this.screenCapturePlugin = new _ScreenCapturePlugin.ScreenCapturePlugin(this);
    this.iframeMessage = (0, _iframeMessagePool.iframeMessagePool)({
      iframeSrc: this.embedScriptContext.getIFrameSrc()
    });
    this.apiUsageTracker = new _ApiUsageTracker.ApiUsageTracker({
      postMessageToIframe: this.iframeMessage.post
    });
    const postMessageApiClient = new _PostMessageApiClient.PostMessageApiClient(this.iframeMessage.post);
    this.pageTitleNotifications = new _PageTitleNotificationsPlugin.default();
    this.postMessageReceiver = new _PostMessageReceiver.PostMessageReceiver({
      [_receivedPostMessageTypes.SHOW_PAGE_TITLE_NOTIFICATION]: this.pageTitleNotifications.handleShow,
      [_receivedPostMessageTypes.CLEAR_PAGE_TITLE_NOTIFICATION]: this.pageTitleNotifications.handleClear,
      [_receivedPostMessageTypes.REQUEST_WIDGET]: this.handleRequestWidget,
      [_sentPostMessageTypes.REFRESH_WIDGET_DATA]: this.requestWidgetRefresh,
      [_receivedPostMessageTypes.IFRAME_RESIZE]: this.handleResizeMessage,
      [_receivedPostMessageTypes.IFRAME_RESIZE_DRAG_EXPAND]: this.handleResizeDragExpand,
      [_receivedPostMessageTypes.STORE_WIDGET_SIZE_PREFERENCE]: this.handleStoreWidgetSizePreference,
      [_receivedPostMessageTypes.OPEN_CHANGE]: this.handleOpenChange,
      [_receivedPostMessageTypes.CLOSED_WELCOME_MESSAGE]: _hideWelcomeMessage.hideWelcomeMessage,
      [_receivedPostMessageTypes.STORE_MESSAGES_COOKIE]: this.handleStoreMessagesCookie,
      [_receivedPostMessageTypes.EXTERNAL_API_EVENT]: this.handleExternalApiEventMessage,
      [_receivedPostMessageTypes.API_REQUEST]: postMessageApiClient.makeApiRequest,
      [_receivedPostMessageTypes.I18N_LABELS]: this.handleI18nLabels,
      [_receivedPostMessageTypes.SCREEN_CAPTURE_REQUEST]: this.screenCapturePlugin.handleScreenCaptureRequest,
      [_receivedPostMessageTypes.DRAG_HANDLE_POSITION_CHANGE]: this.handleDragHandlePositionChange,
      [_receivedPostMessageTypes.INPUT_TEXT_CHANGED]: this.handleInputTextChanged,
      [_receivedPostMessageTypes.RESTORE_SAVED_LAUNCHER_POSITION]: this.handleRestoreSavedLauncherPosition,
      [_receivedPostMessageTypes.RESET_TO_DEFAULT_LAUNCHER_POSITION]: this.handleResetToDefaultLauncherPosition
    }, {
      allowedOrigin: this.embedScriptContext.getIFrameDomain(),
      iframeUuid: this.embedScriptContext.iframeUuid
    });
    this.exitIntentTracker.registerPostMessageReceivers(this.postMessageReceiver);
    this.scrollPercentageTracker.registerPostMessageReceivers(this.postMessageReceiver);
  }
  handleExternalApiEventMessage(message) {
    (0, _handleExternalApiEventMessage.handleExternalApiEventMessage)(message, {
      eventEmitter: this.eventEmitter
    });
  }
  handleScroll({
    scrollPercentage
  }) {
    this.iframeMessage.post(_sentPostMessageTypes.SCROLL_PERCENTAGE_CHANGE, {
      scrollPercentage
    });
  }

  /**
   *
   * @param {MouseEvent} e
   */

  /**
   *
   * @param {MouseEvent} e
   */

  handleExitIntent() {
    this.iframeMessage.post(_sentPostMessageTypes.EXIT_INTENT);
  }
  getStatus() {
    return {
      loaded: this.hasLoadedIframe,
      pending: this.isLoadingIframe
    };
  }

  /**
   * Provides default size for chat launcher
   * to reduce CLS on page load.
   */

  handleIframeLoad() {
    setTimeout(() => this.eventEmitter.trigger('widgetLoaded', {
      message: 'widget has loaded'
    }));
    this.handleWindowResize();
    this.hasLoadedIframe = true;
    this.isLoadingIframe = false;
    (0, _markEnd.markEndPostDelay)();
    this.postPerfAttributes(this.embedScriptContext.getPerfAttributes());
  }
  postPerfAttributes(perfAttributes) {
    // Only send these metrics 50% of the time to
    // stay further away from our New Relic data limit
    if (Math.random() < 0.5) {
      this.iframeMessage.post(_sentPostMessageTypes.PERF_ATTRIBUTES, {
        perfAttributes
      });
    }
  }
  resetAndReloadWidget() {
    this.removeIframe();
    (0, _resetAndLaunchWidget.resetAndLaunchWidget)();
  }
  removeIframe() {
    this.unintializeDrag();
    const iframeContainer = (0, _settingsHelpers.shouldEmbedInline)() ? document.getElementById(_elementSelectors.INLINE_PARENT_ID) : document.getElementById(_elementSelectors.PARENT_ID);
    if (iframeContainer) {
      iframeContainer.remove();
    }
    this.iframeSrc = null;
    this.hasLoadedIframe = false;
    this.isLoadingIframe = false;
  }
  handleResizeMessage({
    data: {
      height,
      width
    } = {}
  }) {
    (0, _resizeWidgetIframe.resizeWidgetIframe)({
      height,
      width
    });
    this.clampPosition();
  }
  handleResizeDragExpand({
    data: {
      height,
      width
    } = {}
  }) {
    (0, _resizeWidgetIframe.resizeWidgetIframe)({
      height,
      width
    });
  }
  setWidgetOpenCookie({
    isOpen
  }) {
    (0, _operators.setCookie)(_constants.cookies.IS_OPEN, isOpen, _times.default.THIRTY_MINUTES);
  }
  handleOpenChange({
    data: {
      isOpen,
      isUser
    }
  }) {
    const html = document.documentElement;
    const parent = document.getElementById(_elementSelectors.PARENT_ID);
    const shadowContainer = parent.getElementsByClassName(_widgetClassNames.SHADOW_CONTAINER)[0];
    this.isOpen = isOpen;
    if (isUser) {
      this.setWidgetOpenCookie({
        isOpen: this.isOpen
      });
    }
    if (this.isOpen) {
      html.classList.add(_widgetClassNames.ACTIVE);
      shadowContainer.classList.add('active');
    } else {
      html.classList.remove(_widgetClassNames.ACTIVE);
      shadowContainer.classList.remove('active');
    }
  }
  handleDragHandlePositionChange({
    data: {
      dragHandleState
    }
  }) {
    const {
      draggable,
      routingRuleDefinitionAI,
      message,
      systemChatflow
    } = this.widgetData;
    const launcherType = (message === null || message === void 0 ? void 0 : message.launcherType) || _launcherTypes.DEFAULT;
    const isAIChatBot = Boolean(routingRuleDefinitionAI);
    const isClosingAgentSystemChatflow = Boolean(systemChatflow);
    const usePillLauncher = (isAIChatBot || isClosingAgentSystemChatflow) && (launcherType === _launcherTypes.PILL || launcherType === _launcherTypes.DEFAULT);
    if (!draggable || (0, _whichDevice.isAnyMobile)() || (0, _getExternalApiSettings.getExternalApiSettings)().isFullscreen) {
      return;
    }
    const widgetAlignment = this.widgetData[_widgetDataKeys.WIDGET_LOCATION] === 'RIGHT_ALIGNED' ? 'right' : 'left';
    const removeDragHandleClasses = () => {
      if (this.dragHandleEl) {
        Array.from(this.dragHandleEl.classList).forEach(cls => {
          if (cls.startsWith('hs-drag-handle--')) {
            var _this$dragHandleEl;
            (_this$dragHandleEl = this.dragHandleEl) === null || _this$dragHandleEl === void 0 || _this$dragHandleEl.classList.remove(cls);
          }
        });
      }
    };
    if (this.dragHandleEl) {
      removeDragHandleClasses();
      if (dragHandleState === 'hidden') {
        this.dragHandleEl.style.setProperty('display', 'none');
      } else {
        this.dragHandleEl.style.setProperty('display', 'flex');
      }
      if (usePillLauncher) {
        this.dragHandleEl.classList.add(`hs-drag-handle--v2--${dragHandleState}--${widgetAlignment}`);
      } else {
        this.dragHandleEl.classList.add(`hs-drag-handle--v1--${widgetAlignment}`);
      }
    }
  }
  handleInputTextChanged({
    data: {
      text
    }
  }) {
    this.eventEmitter.trigger(_eventTypeConstants.INPUT_TEXT_CHANGED, {
      text
    });
  }
  handleRestoreSavedLauncherPosition() {
    var _this$widgetData2;
    if (!((_this$widgetData2 = this.widgetData) !== null && _this$widgetData2 !== void 0 && _this$widgetData2.draggable) || (0, _whichDevice.isAnyMobile)() || (0, _getExternalApiSettings.getExternalApiSettings)().isFullscreen) {
      return;
    }
    const parent = document.getElementById(_elementSelectors.PARENT_ID);
    if (!parent) return;
    const savedPosition = this.getStartPosition();
    if (savedPosition) {
      const isRightAligned = this.widgetData[_widgetDataKeys.WIDGET_LOCATION] === 'RIGHT_ALIGNED';
      const widgetAlignment = isRightAligned ? 'right' : 'left';
      parent.style.setProperty(widgetAlignment, `${savedPosition.horizontal}px`, 'important');
      parent.style.setProperty('bottom', `${savedPosition.bottom}px`, 'important');
    }
  }
  handleResetToDefaultLauncherPosition() {
    const parent = document.getElementById(_elementSelectors.PARENT_ID);
    if (!parent) return;
    parent.style.removeProperty('right');
    parent.style.removeProperty('left');
    parent.style.removeProperty('bottom');
  }
  handleRequestWidget({
    source
  }) {
    (0, _sendWidgetDataToIframe.sendWidgetDataToIframe)({
      source,
      widgetData: this.widgetData,
      embedScriptContext: this.embedScriptContext,
      apiUsageTracker: this.apiUsageTracker
    });
    const savedSize = this.getWidgetSizePreference();
    if (savedSize) {
      this.iframeMessage.post(_sentPostMessageTypes.WIDGET_SIZE_PREFERENCE, savedSize);
    }
  }
  getWidgetSizePreference() {
    const raw = (0, _operators.getCookie)(_constants.cookies.WIDGET_SIZE);
    if (!raw) return null;
    try {
      return JSON.parse(raw);
    } catch (_unused) {
      return null;
    }
  }
  handleStoreWidgetSizePreference({
    data
  }) {
    (0, _operators.setCookie)(_constants.cookies.WIDGET_SIZE, JSON.stringify(data), _times.default.SIX_MONTHS);
  }
  handleStoreMessagesCookie({
    data
  }) {
    this.iframeMessage.post(_sentPostMessageTypes.FIRST_VISITOR_SESSION, {
      isFirstVisitorSession: false
    });
    if ((0, _getGlobalCookieOptOut.getGlobalCookieOptOut)() === 'yes' && this.widgetData.gdprConsentOptions.cookieConsentPrompt !== _gdprCookieConsentTypes.NEVER) {
      window._hsp.push(['showBanner']);
    }
    (0, _setMessagesUtk.setMessagesUtk)(data);
  }
  requestWidgetOpen() {
    if (this.isOpen) {
      this.devLogger.log('cannot open the widget, it is already open.');
      return;
    }
    this.iframeMessage.post(_sentPostMessageTypes.REQUEST_OPEN);
  }
  requestWidgetClose() {
    if (!this.isOpen) {
      this.devLogger.log('cannot close the widget, it is already closed');
      return;
    }
    this.iframeMessage.post(_sentPostMessageTypes.REQUEST_CLOSE);
  }
  requestOpenToKBContent(data) {
    var _this$widgetData$mess;
    if (!this.hasLoadedIframe) {
      this.devLogger.log('cannot open to knowledge base, widget is not loaded');
      return;
    }
    if (!((_this$widgetData$mess = this.widgetData.message) !== null && _this$widgetData$mess !== void 0 && _this$widgetData$mess.knowledgeBaseEnabled)) {
      this.devLogger.log('cannot open to knowledge base, knowledge base is not enabled');
      return;
    }
    this.iframeMessage.post(_sentPostMessageTypes.OPEN_TO_KB_CONTENT, data);
  }
  requestSetInputText(text, sendMessage) {
    if (!this.iframe) {
      this.devLogger.log('cannot set input text, widget is not loaded');
      return;
    }
    this.iframeMessage.post(_sentPostMessageTypes.SET_INPUT_TEXT, {
      text,
      sendMessage
    });
  }
  handleWindowResize() {
    const data = {
      height: window.innerHeight,
      width: window.innerWidth
    };
    this.iframeMessage.post(_sentPostMessageTypes.BROWSER_WINDOW_RESIZE, data);
    this.clampPosition();
  }
  requestWidgetRefresh({
    openToNewThread,
    setIdentification = false
  } = {}) {
    const {
      portalId
    } = this.embedScriptContext;
    if (!this.hasLoadedIframe && this.isLoadingIframe) {
      this.devLogger.log('Cannot refresh the widget - it is currently loading.');
      return;
    }
    if (this.hasLoadedIframe) {
      const requestUrl = this.embedScriptContext.getInitialRequestUrl(setIdentification);
      if (setIdentification) {
        this.postVisitorIdentificationAttributes();
      }
      (0, _fetchWidgetData.fetchWidgetData)({
        requestUrl,
        portalId
      }, widgetData => {
        this.handleWidgetRefresh(widgetData);
        if (openToNewThread) {
          this.openToNewThread();
        }
      });
    } else {
      this.loadWidget();
      if (openToNewThread) {
        this.openToNewThread();
      }
    }
  }
  openToNewThread() {
    this.iframeMessage.post(_sentPostMessageTypes.OPEN_TO_NEW_THREAD);
  }
  extendedClearCookiesFunction(extendedFunction) {
    if (extendedFunction && extendedFunction[_extendedFunctions.RESET_WIDGET]) {
      this.removeIframe();
    }
    (0, _clearCookies.clearCookies)(extendedFunction);
  }
  handleWidgetRefresh(refreshedWidgetData) {
    this.setWidgetData(refreshedWidgetData);
    const shouldHideWidget = (0, _getWidgetDataResponseType.getWidgetDataResponseType)(this.widgetData) === _widgetResponseTypes.HIDE_WIDGET;
    if (shouldHideWidget) {
      this.removeIframe();
    } else {
      this.iframeMessage.post(_sentPostMessageTypes.REFRESH_WIDGET_DATA, Object.assign({}, this.widgetData, (0, _getIframeQueryParams.getIframeQueryParams)(this.embedScriptContext)));
    }
  }
  setWidgetNotLoaded({
    reason,
    description
  }) {
    this.hasLoadedIframe = false;
    this.isLoadingIframe = false;
    if (reason || description) {
      this.eventEmitter.trigger(_eventTypeConstants.WIDGET_HIDDEN, {
        reason,
        description
      });
    }
  }

  /*
   * Load widget data for the current page
   *
   * @param {object}   options
   * @param {boolean} [options.widgetOpen] - whether or not the widget should render
   *                                         in an open state on initial load
   */
  loadWidget(options = {}) {
    const {
      portalId
    } = this.embedScriptContext;
    if (this.isLoadingIframe) {
      this.devLogger.log('Cannot load the widget - The widget is already being loaded.');
      return;
    }
    if (this.hasLoadedIframe) {
      this.devLogger.log('Cannot load the widget - the widget has already loaded.');
      return;
    }
    this.isLoadingIframe = true;
    if (options.widgetOpen) {
      this.setWidgetOpenCookie({
        isOpen: true
      });
    }
    (0, _fetchWidgetData.fetchWidgetData)({
      requestUrl: this.embedScriptContext.getInitialRequestUrl(),
      portalId
    }, (0, _handleTargetingAndDelay.handleTargetingAndDelay)(this.setWidgetData, this.loadIFrame, this.setWidgetNotLoaded), () => {
      _events.EVENTS.messagesInitialized({
        messageWillRender: false
      });
    });
  }
  start() {
    const {
      shouldRender
    } = (0, _shouldRenderWidget.shouldRenderWidget)(this.embedScriptContext);
    if (!shouldRender) {
      try {
        // Prototype can cause this to fail
        _events.EVENTS.messagesInitialized({
          messageWillRender: false
        });
      } catch (e) {
        this.devLogger.log(`widget load aborted`);
      }
      return;
    }
    (0, _setupExternalApi.setupExternalApi)({
      debug: this.devLogger.debug,
      on: (eventName, listener) => {
        this.eventEmitter.on(eventName, listener);
        this.apiUsageTracker.trackEventListener(eventName);
      },
      off: this.eventEmitter.off,
      clear: args => {
        this.extendedClearCookiesFunction(args);
        this.apiUsageTracker.trackMethod('clear');
      },
      resetAndReloadWidget: this.resetAndReloadWidget,
      widget: {
        load: (...args) => {
          this.loadWidget(...args);
          this.apiUsageTracker.trackMethod('load');
        },
        remove: () => {
          this.removeIframe();
          this.apiUsageTracker.trackMethod('remove');
        },
        open: () => {
          this.requestWidgetOpen();
          this.apiUsageTracker.trackMethod('open');
        },
        close: () => {
          this.requestWidgetClose();
          this.apiUsageTracker.trackMethod('close');
        },
        refresh: (...args) => {
          this.requestWidgetRefresh(...args);
          this.apiUsageTracker.trackMethod('refresh');
        },
        status: () => {
          this.apiUsageTracker.trackMethod('status');
          return this.getStatus();
        },
        updateEntryUrlMetadata: overrides => {
          this.postEntryUrlMetadata(overrides);
          this.apiUsageTracker.trackMethod('updateEntryUrlMetadata');
        },
        setInputText: (text, sendMessage) => {
          this.requestSetInputText(text, sendMessage);
          this.apiUsageTracker.trackMethod('setInputText');
        },
        openToKnowledgeBase: () => {
          this.requestOpenToKBContent({
            type: 'knowledge-base'
          });
          this.apiUsageTracker.trackMethod('openToKnowledgeBase');
        },
        openToCategory: categoryId => {
          this.requestOpenToKBContent({
            type: 'category',
            categoryId
          });
          this.apiUsageTracker.trackMethod('openToCategory');
        }
      }
    });
    (0, _flushOnReadyCallbacks.flushOnReadyCallbacks)({
      logger: this.devLogger,
      trackCallback: this.apiUsageTracker.trackOnReady
    });
    (0, _registerHashChangeListener.registerHashChangeListener)({
      requestWidgetOpen: this.requestWidgetOpen,
      isOpen: this.isOpen
    });
    (0, _registerWindowResizeListener.registerWindowResizeListener)({
      resizeCallbackFn: this.handleWindowResize
    });
    (0, _registerCookieListeners.registerCookieListeners)({
      postMessageToIframe: this.iframeMessage.post
    });
    if ((0, _settingsHelpers.shouldLoadImmediately)()) {
      this.loadWidget();
    }
    this.postVisitorIdentificationAttributes();
    this.postEntryUrlMetadata();
    this.registerEntryUrlMetadataObserver();
  }
  postVisitorIdentificationAttributes() {
    const {
      identificationEmail,
      identificationToken
    } = this.embedScriptContext;
    this.iframeMessage.post(_sentPostMessageTypes.VISITOR_IDENTIFICATION_ATTRIBUTES, {
      identificationEmail,
      identificationToken
    });
  }
  postEntryUrlMetadata(overrides) {
    var _document$querySelect;
    const title = typeof (overrides === null || overrides === void 0 ? void 0 : overrides.title) === 'string' ? overrides.title : document.title;
    const description = typeof (overrides === null || overrides === void 0 ? void 0 : overrides.description) === 'string' ? overrides.description : ((_document$querySelect = document.querySelector('meta[name="description"]')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.getAttribute('content')) || '';
    this.iframeMessage.post(_sentPostMessageTypes.ENTRY_URL_METADATA, {
      title,
      description
    });
  }
  registerEntryUrlMetadataObserver() {
    const titleTarget = document.querySelector('title');
    const metaDescTarget = document.querySelector('meta[name="description"]');
    const observer = new MutationObserver(mutations => {
      if (!this.pageTitleNotifications.notificationIntervalIsRunning()) {
        mutations.forEach(() => {
          setTimeout(() => {
            this.postEntryUrlMetadata();
          }, 0);
        });
      }
    });
    if (titleTarget) {
      observer.observe(titleTarget, {
        childList: true
      });
    }
    if (metaDescTarget) {
      observer.observe(metaDescTarget, {
        attributes: true
      });
    }
  }
  setFrameClass() {
    const parent = document.getElementById(_elementSelectors.PARENT_ID);
    if (!parent) return;
    const widgetLocation = this.widgetData[_widgetDataKeys.WIDGET_LOCATION];
    (0, _setClassInClassList.setClassInClassList)({
      widgetLocation,
      classList: parent.classList
    });
  }
}
exports.WidgetShell = WidgetShell;